/**
 * @generated SignedSource<<9e6c41e158c5e5325e3bdd4e416458ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditPageQuery$variables = {
  first: number;
  id: string;
};
export type PackageEditPageQuery$data = {
  readonly package: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"PackageEditTabs_package" | "PackageSidebar_package">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTabs_data">;
};
export type PackageEditPageQuery = {
  response: PackageEditPageQuery$data;
  variables: PackageEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v3/*: any*/)
],
v10 = [
  (v7/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
],
v11 = [
  (v7/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceLive",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "departDatetime",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "departAirportCode",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "arrivalAirportCode",
  "storageKey": null
},
v18 = [
  (v7/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arrivalDatetime",
    "storageKey": null
  },
  (v17/*: any*/)
],
v19 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "S120X120"
    }
  ],
  "kind": "ScalarField",
  "name": "externalUrl",
  "storageKey": "externalUrl(size:\"S120X120\")"
},
v22 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "w262"
    }
  ],
  "kind": "ScalarField",
  "name": "src",
  "storageKey": "src(size:\"w262\")"
},
v23 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nameString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "capacity",
    "storageKey": null
  }
],
v24 = [
  (v7/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "etgKey",
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = [
  (v25/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isFlightSegmentType"
  },
  (v7/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v28 = [
  (v3/*: any*/),
  (v7/*: any*/)
],
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Service",
  "kind": "LinkedField",
  "name": "allServices",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "package",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageEditTabs_package"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageSidebar_package"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PackageEditTabs_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PackageEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "package",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": "allDates",
            "args": (v4/*: any*/),
            "concreteType": "PackageDateConnection",
            "kind": "LinkedField",
            "name": "tripDates",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "tripDates(first:2147483647)"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "MediaConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "media(first:2147483647)"
          },
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markupType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markupValueAdult",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markupValueChild",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validBeforeTripStartDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingPaymentDeadlineDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "individualAdvance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alreadyPurchased",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notesTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notesText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organiser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "labels",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WhatToSee",
            "kind": "LinkedField",
            "name": "whatToSee",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Term",
            "kind": "LinkedField",
            "name": "included",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Term",
            "kind": "LinkedField",
            "name": "excluded",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TravelDocument",
            "kind": "LinkedField",
            "name": "documents",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transportType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalFlights",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transportName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transferPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "services",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Airport",
            "kind": "LinkedField",
            "name": "defaultDepartureAirport",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Airport",
            "kind": "LinkedField",
            "name": "defaultArrivalAirport",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": "dates",
            "args": (v4/*: any*/),
            "concreteType": "PackageDateConnection",
            "kind": "LinkedField",
            "name": "tripDates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PackageDate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flight",
                        "kind": "LinkedField",
                        "name": "flight",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forwardFlightNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "returnFlightNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forwardChangeDuration",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "returnChangeDuration",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlightSegment",
                            "kind": "LinkedField",
                            "name": "forwardSegments",
                            "plural": true,
                            "selections": (v18/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlightSegment",
                            "kind": "LinkedField",
                            "name": "returnSegments",
                            "plural": true,
                            "selections": (v18/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": "tripDates(first:2147483647)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hotel",
            "kind": "LinkedField",
            "name": "hotel",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destination",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Media",
                "kind": "LinkedField",
                "name": "mainMedia",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Text",
                "kind": "LinkedField",
                "name": "descriptionText",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextBlock",
                    "kind": "LinkedField",
                    "name": "activeBlock",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "RoomConnection",
                "kind": "LinkedField",
                "name": "rooms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoomEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Room",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rooms(first:2147483647)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CateringOption",
            "kind": "LinkedField",
            "name": "cateringOptions",
            "plural": true,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Room",
            "kind": "LinkedField",
            "name": "rooms",
            "plural": true,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupedRate",
            "kind": "LinkedField",
            "name": "groupedRates",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDate",
                "kind": "LinkedField",
                "name": "date",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flight",
                    "kind": "LinkedField",
                    "name": "flight",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateByCatering",
                "kind": "LinkedField",
                "name": "ratesByCatering",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CateringOption",
                    "kind": "LinkedField",
                    "name": "cateringOption",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateByRoom",
                    "kind": "LinkedField",
                    "name": "ratesByRoom",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Room",
                        "kind": "LinkedField",
                        "name": "room",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoomRate",
                        "kind": "LinkedField",
                        "name": "roomRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roomPriceAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tripPriceAdult",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "priceNett",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roomPriceChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tripPriceChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseCostAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseCostChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPercentMarkup",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPercentAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPercentChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupAmountAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupAmountChild",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              }
            ],
            "concreteType": "PackageDateConnection",
            "kind": "LinkedField",
            "name": "tripDates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PackageDate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validTo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "duration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accommodationPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flight",
                        "kind": "LinkedField",
                        "name": "flight",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUpdating",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlightPrice",
                            "kind": "LinkedField",
                            "name": "lastUpdate",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "forwardSegments",
                                "plural": true,
                                "selections": (v26/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "returnSegments",
                                "plural": true,
                                "selections": (v26/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "FlightType",
                            "abstractKey": "__isFlightType"
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletable",
                            "storageKey": null
                          }
                        ],
                        "type": "Entity",
                        "abstractKey": "__isEntity"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoHotelPriceUpdate",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v25/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Seo",
                "kind": "LinkedField",
                "name": "seo",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Seoable",
            "abstractKey": "__isSeoable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LogEntry",
                "kind": "LinkedField",
                "name": "logs",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Logable",
            "abstractKey": "__isLogable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "cities",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "allLabels",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "allWhatToSees",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v29/*: any*/),
        "concreteType": "TermConnection",
        "kind": "LinkedField",
        "name": "terms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TermEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Term",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "terms(first:10)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TravelDocument",
        "kind": "LinkedField",
        "name": "allTravelDocuments",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ServiceGroup",
        "kind": "LinkedField",
        "name": "allServiceGroups",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v3/*: any*/),
          (v30/*: any*/)
        ],
        "storageKey": null
      },
      (v30/*: any*/),
      {
        "alias": null,
        "args": (v29/*: any*/),
        "concreteType": "Airport",
        "kind": "LinkedField",
        "name": "airports",
        "plural": true,
        "selections": (v11/*: any*/),
        "storageKey": "airports(first:10)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CateringOption",
        "kind": "LinkedField",
        "name": "allCateringOptions",
        "plural": true,
        "selections": (v24/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a786bd8638d0fe4052bafb2e2fa629e",
    "id": null,
    "metadata": {},
    "name": "PackageEditPageQuery",
    "operationKind": "query",
    "text": "query PackageEditPageQuery(\n  $id: ID!\n  $first: Int!\n) {\n  package(id: $id) {\n    name\n    ...PackageEditTabs_package\n    ...PackageSidebar_package\n    id\n  }\n  ...PackageEditTabs_data\n}\n\nfragment AirportSelect_data on Query {\n  airports(first: 10) {\n    id\n    name\n    code\n  }\n}\n\nfragment AssignHotelToPackageDialog_package on Package {\n  id\n}\n\nfragment CategoriesSelect_data on Query {\n  allCategories {\n    id\n    name\n  }\n}\n\nfragment CateringOptionName_cateringOption on CateringOption {\n  name\n  etgKey\n}\n\nfragment CitySelect_data on Query {\n  cities {\n    id\n    name\n    region {\n      id\n      name\n      country {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment CopyFlightButton_packageDate on PackageDate {\n  id\n  flight {\n    forwardFlightNumber\n    returnFlightNumber\n    id\n  }\n}\n\nfragment EntityHistoryEntryIcon_entry on LogEntry {\n  severity\n}\n\nfragment EntityHistoryEntry_entry on LogEntry {\n  name\n  createdAt\n  description\n  user {\n    name\n    id\n  }\n  ...EntityHistoryJsonContext_entry\n  ...EntityHistoryEntryIcon_entry\n}\n\nfragment EntityHistoryJsonContext_entry on LogEntry {\n  context\n}\n\nfragment EntityHistory_entity on Logable {\n  __isLogable: __typename\n  logs {\n    id\n    ...EntityHistoryEntry_entry\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment FlightSearchForm_data on Query {\n  ...AirportSelect_data\n}\n\nfragment FlightSearchForm_defaultArrivalAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment FlightSearchForm_defaultDepartureAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment FlightSegments_segments on FlightSegment {\n  id\n  departDatetime\n  departAirportCode\n  arrivalDatetime\n  arrivalAirportCode\n}\n\nfragment FlightShortDetailsSegments_segments on FlightSegmentType {\n  __isFlightSegmentType: __typename\n  id\n  departDatetime\n  departAirportCode\n  arrivalAirportCode\n}\n\nfragment FlightShortDetails_flight on FlightType {\n  __isFlightType: __typename\n  id\n  forwardSegments {\n    __typename\n    ...FlightShortDetailsSegments_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightShortDetailsSegments_segments\n    id\n  }\n}\n\nfragment LabelsSelect_data on Query {\n  allLabels {\n    id\n    name\n  }\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment PackageAutoHotelPriceUpdateSwitch_package on Package {\n  id\n  autoHotelPriceUpdate\n}\n\nfragment PackageDateAddFlightDialog_data on Query {\n  ...FlightSearchForm_data\n}\n\nfragment PackageDateAddFlightDialog_package on Package {\n  defaultDepartureAirport {\n    ...FlightSearchForm_defaultDepartureAirport\n    id\n  }\n  defaultArrivalAirport {\n    ...FlightSearchForm_defaultArrivalAirport\n    id\n  }\n}\n\nfragment PackageDateAddFlightDialog_packageDate on PackageDate {\n  id\n  start\n  end\n}\n\nfragment PackageDateRowFlightDetails_data on Query {\n  ...PackageDateAddFlightDialog_data\n}\n\nfragment PackageDateRowFlightDetails_package on Package {\n  transportType\n  ...PackageDateAddFlightDialog_package\n}\n\nfragment PackageDateRowFlightDetails_packageDate on PackageDate {\n  flight {\n    id\n    priceLive\n    lastUpdate {\n      status\n      id\n    }\n    ...FlightShortDetails_flight\n  }\n  ...PackageDateAddFlightDialog_packageDate\n}\n\nfragment PackageDateRowFlightPrice_flight on Flight {\n  priceLive\n  isUpdating\n}\n\nfragment PackageDateRowFlight_data on Query {\n  ...PackageDateRowFlightDetails_data\n}\n\nfragment PackageDateRowFlight_package on Package {\n  transportType\n  externalFlights\n  ...PackageDateRowFlightDetails_package\n}\n\nfragment PackageDateRowFlight_packageDate on PackageDate {\n  flight {\n    ...PackageDateRowFlightPrice_flight\n    id\n  }\n  ...PackageDateRowFlightDetails_packageDate\n}\n\nfragment PackageDateRow_data on Query {\n  ...PackageDateRowFlight_data\n}\n\nfragment PackageDateRow_package on Package {\n  status\n  ...PackageDateRowFlight_package\n}\n\nfragment PackageDateRow_packageDate on PackageDate {\n  id\n  start\n  end\n  validTo\n  duration\n  accommodationPrice\n  ...EntityTableRow_entity\n  ...PackageDateRowFlight_packageDate\n  ...PackageDateStatus_packageDate\n}\n\nfragment PackageDateStatus_packageDate on PackageDate {\n  status\n}\n\nfragment PackageEditAccommodation_data on Query {\n  ...PackageEditAccomodationPrices_data\n}\n\nfragment PackageEditAccommodation_package on Package {\n  hotel {\n    id\n  }\n  ...PackageEditAccomodationHotel_package\n  ...PackageEditAccomodationPrices_package\n  ...AssignHotelToPackageDialog_package\n}\n\nfragment PackageEditAccomodationHotel_package on Package {\n  id\n  hotel {\n    id\n    name\n    destination\n    mainMedia {\n      ...MediaThumb_media\n      id\n    }\n    descriptionText {\n      activeBlock {\n        data\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment PackageEditAccomodationPrices_data on Query {\n  ...RoomRatesToolbar_data\n  ...RoomRatesEditorInit_data\n}\n\nfragment PackageEditAccomodationPrices_package on Package {\n  cateringOptions {\n    id\n  }\n  rooms {\n    id\n  }\n  ...RoomRatesTable_package\n  ...RoomRatesEditorInit_package\n  ...RoomRatesToolbar_package\n}\n\nfragment PackageEditDatesAdd_package on Package {\n  id\n}\n\nfragment PackageEditDatesList_data on Query {\n  ...PackageDateRow_data\n}\n\nfragment PackageEditDatesList_package_3ASum4 on Package {\n  id\n  transportType\n  externalFlights\n  tripDates(first: $first) {\n    edges {\n      node {\n        id\n        ...PackageDateRow_packageDate\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...PackageDateRow_package\n  ...PackageEditDatesAdd_package\n}\n\nfragment PackageEditDates_data on Query {\n  ...PackageEditDatesList_data\n}\n\nfragment PackageEditDates_package on Package {\n  ...PackageEditDatesAdd_package\n  ...PackageEditDatesList_package_3ASum4\n}\n\nfragment PackageEditMainDocuments_data on Query {\n  ...TravelDocumentSelect_data\n}\n\nfragment PackageEditMainGeneral_data on Query {\n  ...CitySelect_data\n}\n\nfragment PackageEditMainPresentation_data on Query {\n  ...CategoriesSelect_data\n  ...LabelsSelect_data\n  ...WhatToSeeSelect_data\n}\n\nfragment PackageEditMainTerms_data on Query {\n  ...TermsSelect_data\n}\n\nfragment PackageEditMain_data on Query {\n  ...PackageEditMainGeneral_data\n  ...PackageEditMainPresentation_data\n  ...PackageEditMainTerms_data\n  ...PackageEditMainDocuments_data\n}\n\nfragment PackageEditMain_package on Package {\n  id\n  name\n  status\n  subtitle\n  markupType\n  markupValueAdult\n  markupValueChild\n  validBeforeTripStartDays\n  remainingPaymentDeadlineDays\n  individualAdvance\n  alreadyPurchased\n  descriptionTitle\n  descriptionText\n  notesTitle\n  notesText\n  organiser\n  city {\n    id\n    name\n  }\n  categories {\n    id\n    name\n  }\n  labels {\n    id\n    name\n  }\n  whatToSee {\n    id\n    name\n  }\n  included {\n    id\n    name\n    icon\n  }\n  excluded {\n    id\n    name\n    icon\n  }\n  documents {\n    id\n    name\n  }\n}\n\nfragment PackageEditTabs_data on Query {\n  ...PackageEditMain_data\n  ...PackageEditTransport_data\n  ...PackageEditAccommodation_data\n  ...PackageEditDates_data\n}\n\nfragment PackageEditTabs_package on Package {\n  allDates: tripDates(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  media(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  ...MediaEditor_mediable\n  ...PackageEditMain_package\n  ...PackageEditTransport_package\n  ...PackageEditAccommodation_package\n  ...PackageEditDates_package\n  ...SeoTab_seoable\n  ...EntityHistory_entity\n}\n\nfragment PackageEditTransportFlightsRowActions_data on Query {\n  ...PackageDateAddFlightDialog_data\n}\n\nfragment PackageEditTransportFlightsRowActions_package on Package {\n  ...PackageDateAddFlightDialog_package\n}\n\nfragment PackageEditTransportFlightsRowActions_packageDate on PackageDate {\n  id\n  flight {\n    id\n  }\n  ...PackageDateAddFlightDialog_packageDate\n  ...CopyFlightButton_packageDate\n}\n\nfragment PackageEditTransportFlightsRow_data on Query {\n  ...PackageEditTransportFlightsRowActions_data\n}\n\nfragment PackageEditTransportFlightsRow_package on Package {\n  ...PackageEditTransportFlightsRowActions_package\n}\n\nfragment PackageEditTransportFlightsRow_packageDate on PackageDate {\n  id\n  start\n  end\n  flight {\n    id\n    forwardFlightNumber\n    returnFlightNumber\n    forwardChangeDuration\n    returnChangeDuration\n    priceLive\n    forwardSegments {\n      ...FlightSegments_segments\n      id\n    }\n    returnSegments {\n      ...FlightSegments_segments\n      id\n    }\n  }\n  ...PackageEditTransportFlightsRowActions_packageDate\n}\n\nfragment PackageEditTransportFlights_data on Query {\n  ...PackageEditTransportFlightsRow_data\n  ...AirportSelect_data\n}\n\nfragment PackageEditTransportFlights_package on Package {\n  dates: tripDates(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...PackageEditTransportFlightsRow_packageDate\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...PackageEditTransportFlightsRow_package\n}\n\nfragment PackageEditTransportServices_data on Query {\n  ...ServiceGroupSelect_data\n  ...ServicesSelect_data\n}\n\nfragment PackageEditTransport_data on Query {\n  ...PackageEditTransportServices_data\n  ...PackageEditTransportFlights_data\n}\n\nfragment PackageEditTransport_package on Package {\n  id\n  transportType\n  externalFlights\n  transportName\n  transferPrice\n  services {\n    id\n    name\n  }\n  defaultDepartureAirport {\n    id\n    name\n    code\n  }\n  defaultArrivalAirport {\n    id\n    name\n    code\n  }\n  ...PackageEditTransportFlights_package\n}\n\nfragment PackageSidebar_package on Package {\n  link\n  ...EntitySidebar_entity\n  ...PackageStatus_package\n  ...PackageAutoHotelPriceUpdateSwitch_package\n}\n\nfragment PackageStatus_package on Package {\n  status\n}\n\nfragment RoomNameWithCapacity_room on Room {\n  nameString\n  capacity\n}\n\nfragment RoomRatesEditorCateringSettings_data on Query {\n  allCateringOptions {\n    id\n    name\n    etgKey\n    ...CateringOptionName_cateringOption\n  }\n}\n\nfragment RoomRatesEditorCateringSettings_package on Package {\n  id\n  cateringOptions {\n    id\n  }\n}\n\nfragment RoomRatesEditorInit_data on Query {\n  ...RoomRatesEditorCateringSettings_data\n}\n\nfragment RoomRatesEditorInit_package on Package {\n  cateringOptions {\n    id\n  }\n  rooms {\n    id\n  }\n  ...RoomRatesEditorRoomSettings_package\n  ...RoomRatesEditorCateringSettings_package\n}\n\nfragment RoomRatesEditorRoomSettings_package on Package {\n  id\n  hotel {\n    id\n    rooms(first: 2147483647) {\n      edges {\n        node {\n          id\n          nameString\n          ...RoomNameWithCapacity_room\n        }\n      }\n    }\n  }\n  rooms {\n    id\n  }\n}\n\nfragment RoomRatesEditorSettingsMenuCatering_data on Query {\n  ...RoomRatesEditorCateringSettings_data\n}\n\nfragment RoomRatesEditorSettingsMenuCatering_package on Package {\n  ...RoomRatesEditorCateringSettings_package\n}\n\nfragment RoomRatesEditorSettingsMenuRooms_package on Package {\n  ...RoomRatesEditorRoomSettings_package\n}\n\nfragment RoomRatesEditorSettingsMenu_data on Query {\n  ...RoomRatesEditorSettingsMenuCatering_data\n}\n\nfragment RoomRatesEditorSettingsMenu_package on Package {\n  ...RoomRatesEditorSettingsMenuRooms_package\n  ...RoomRatesEditorSettingsMenuCatering_package\n}\n\nfragment RoomRatesTableDateRow_groupedRate on GroupedRate {\n  date {\n    id\n    start\n    end\n    ...RoomRatesTableRateCell_packageDate\n  }\n  ratesByCatering {\n    cateringOption {\n      id\n      ...CateringOptionName_cateringOption\n      ...RoomRatesTableRateCell_cateringOption\n    }\n    ratesByRoom {\n      ...RoomRatesTableRateCell_rateByRoom\n    }\n  }\n}\n\nfragment RoomRatesTableDateRow_package on Package {\n  ...RoomRatesTableRateCell_package\n}\n\nfragment RoomRatesTableHead_package on Package {\n  rooms {\n    id\n    ...RoomNameWithCapacity_room\n  }\n}\n\nfragment RoomRatesTableRateCellValue_roomRate on RoomRate {\n  roomPriceAdult\n  tripPriceAdult\n}\n\nfragment RoomRatesTableRateCell_cateringOption on CateringOption {\n  id\n  ...RoomRatesTableRateEditor_cateringOption\n}\n\nfragment RoomRatesTableRateCell_package on Package {\n  ...RoomRatesTableRateEditor_package\n}\n\nfragment RoomRatesTableRateCell_packageDate on PackageDate {\n  id\n  ...RoomRatesTableRateEditor_packageDate\n}\n\nfragment RoomRatesTableRateCell_rateByRoom on RateByRoom {\n  room {\n    id\n  }\n  roomRate {\n    ...RoomRatesTableRateCellValue_roomRate\n    id\n  }\n  ...RoomRatesTableRateEditor_rateByRoom\n}\n\nfragment RoomRatesTableRateEditorForm_cateringOption on CateringOption {\n  id\n  ...CateringOptionName_cateringOption\n}\n\nfragment RoomRatesTableRateEditorForm_package on Package {\n  transferPrice\n}\n\nfragment RoomRatesTableRateEditorForm_packageDate on PackageDate {\n  id\n  start\n  end\n  flight {\n    priceLive\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorForm_rateByRoom on RateByRoom {\n  room {\n    ...RoomNameWithCapacity_room\n    id\n  }\n  roomRate {\n    ...RoomRatesTableRateEditorPriceBreakdown_roomRate\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorPriceBreakdown_roomRate on RoomRate {\n  tripPriceAdult\n  tripPriceChild\n  baseCostAdult\n  baseCostChild\n  isPercentMarkup\n  markupPercentAdult\n  markupPercentChild\n  markupAmountAdult\n  markupAmountChild\n}\n\nfragment RoomRatesTableRateEditor_cateringOption on CateringOption {\n  id\n  ...RoomRatesTableRateEditorForm_cateringOption\n}\n\nfragment RoomRatesTableRateEditor_package on Package {\n  ...RoomRatesTableRateEditorForm_package\n}\n\nfragment RoomRatesTableRateEditor_packageDate on PackageDate {\n  id\n  ...RoomRatesTableRateEditorForm_packageDate\n}\n\nfragment RoomRatesTableRateEditor_rateByRoom on RateByRoom {\n  room {\n    id\n  }\n  roomRate {\n    id\n    priceNett\n    roomPriceAdult\n    roomPriceChild\n  }\n  ...RoomRatesTableRateEditorForm_rateByRoom\n}\n\nfragment RoomRatesTable_package on Package {\n  groupedRates {\n    date {\n      id\n    }\n    ...RoomRatesTableDateRow_groupedRate\n  }\n  ...RoomRatesTableHead_package\n  ...RoomRatesTableDateRow_package\n}\n\nfragment RoomRatesToolbar_data on Query {\n  ...RoomRatesEditorSettingsMenu_data\n}\n\nfragment RoomRatesToolbar_package on Package {\n  ...RoomRatesEditorSettingsMenu_package\n}\n\nfragment SeoTab_seoable on Seoable {\n  __isSeoable: __typename\n  id\n  seo {\n    id\n    slug\n    metaTitle\n    metaDescription\n  }\n}\n\nfragment ServiceGroupSelect_data on Query {\n  allServiceGroups {\n    id\n    name\n    allServices {\n      id\n      name\n    }\n  }\n}\n\nfragment ServicesSelect_data on Query {\n  allServices {\n    id\n    name\n  }\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n\nfragment TermsSelect_data on Query {\n  terms(first: 10) {\n    edges {\n      node {\n        id\n        name\n        icon\n      }\n    }\n  }\n}\n\nfragment TravelDocumentSelect_data on Query {\n  allTravelDocuments {\n    id\n    name\n  }\n}\n\nfragment WhatToSeeSelect_data on Query {\n  allWhatToSees {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1ad2f4d7006aa7534b99b225588937a";

export default node;
